import { useSelector } from 'react-redux';
import { RootState } from 'redux/types';

const getSideBarOpen = (store: RootState) => store.wellGuardian.sideBarOpen;
export const useSelectSideBarOpen = () => useSelector(getSideBarOpen);

const getWellInfo = (store: RootState) => store.wellGuardian.wellInfo;
export const useSelectWellInfo = () => useSelector(getWellInfo);

const getAlertsCount = (store: RootState) => store.wellGuardian.alertsCount;
export const useSelectAlertsCount = () => useSelector(getAlertsCount);

const getSelectedAsset = (store: RootState) => store.wellGuardian.selectedAsset;
export const useSelectedAsset = () => useSelector(getSelectedAsset);

const getSelectedSite = (store: RootState) => store.wellGuardian.selectedSite;
export const useSelectedSite = () => useSelector(getSelectedSite);

const getSortCheck = (store: RootState) => store.wellGuardian.sortCheck;
export const useSortCheck = () => useSelector(getSortCheck);

const getSortedWells = (store: RootState) => store.wellGuardian.wellsInfo;
export const useSortedWells = () => useSelector(getSortedWells);

const getWellSortOrder = (store: RootState) => store.wellGuardian.wellSortOrder;
export const useWellSortOrder = () => useSelector(getWellSortOrder);

const getWellSort = (store: RootState) => store.wellGuardian.wellSort;
export const useWellSort = () => useSelector(getWellSort);

const getWellFilter = (store: RootState) => store.wellGuardian.wellFilter;
export const useWellFilter = () => useSelector(getWellFilter);

const getInterventionFilter = (store: RootState) => store.wellGuardian.interventionFilter;
export const useInterventionFilter = () => useSelector(getInterventionFilter);

const getEngineerFilter = (store: RootState) => store.wellGuardian.engineerFilter;
export const useEngineerFilter = () => useSelector(getEngineerFilter);

const getCaseFilter = (store: RootState) => store.wellGuardian.caseFilter;
export const useCaseFilter = () => useSelector(getCaseFilter);

const getPhaseFilter = (store: RootState) => store.wellGuardian.phaseFilter;
export const usePhaseFilter = () => useSelector(getPhaseFilter);

const getPriorityFilter = (store: RootState) => store.wellGuardian.priorityFilter;
export const usePriorityFilter = () => useSelector(getPriorityFilter);

const getScopeFilter = (store: RootState) => store.wellGuardian.scopeFilter;
export const useScopeFilter = () => useSelector(getScopeFilter);

const getSynergiCount = (store: RootState) => store.wellGuardian.synergiCount;
export const useSynergiCount = () => useSelector(getSynergiCount);

const getDerogCount = (store: RootState) => store.wellGuardian.derogCount;
export const useDerogCount = () => useSelector(getDerogCount);

const getIsSiteLayoutAvailable = (store: RootState) => store.wellGuardian.isSiteLayoutAvailable;
export const useIsSiteLayoutAvailable = () => useSelector(getIsSiteLayoutAvailable);

const getSiteActiveAlerts = (store: RootState) => store.wellGuardian.siteActiveAlerts;
export const useSiteActiveAlerts = () => useSelector(getSiteActiveAlerts);

const getWellManagementModal = (store: RootState) => store.wellGuardian.wellManagementModal;
export const useWellManagementModal = () => useSelector(getWellManagementModal);

const getWellData = (store: RootState) => store.wellGuardian.wellData;
export const useWellData = () => useSelector(getWellData);

const getAllWellsSearchInput = (store: RootState) => store.wellGuardian.allWellsSearchInput;
export const useAllWellsSearchInput = () => useSelector(getAllWellsSearchInput);

const getReloadFetch = (store: RootState) => store.wellGuardian.fetchReload;
export const useReloadFetch = () => useSelector(getReloadFetch);

const getAllWellsViewMode = (store: RootState) => store.wellGuardian.allWellsViewMode;
export const useAllWellsViewMode = () => useSelector(getAllWellsViewMode);

const getReTrigger = (store: RootState) => store.wellGuardian.reTrigger;
export const useReTrigger = () => useSelector(getReTrigger);

const getSelectedWIR = (store: RootState) => store.wellGuardian.selectedWIR;
export const useSelectedWIR = () => useSelector(getSelectedWIR);

const getSelectTab = (store: RootState) => store.wellGuardian.selectTab;
export const useSelectedTab = () => useSelector(getSelectTab);

const getErrorCheck = (store: RootState) => store.wellGuardian.errorCheck;
export const useErrorCheck = () => useSelector(getErrorCheck);

const getOriginalSelectedWIR = (store: RootState) => store.wellGuardian.originalSelectedWIR;
export const useOriginalSelectedWIR = () => useSelector(getOriginalSelectedWIR);

const getSelectedSection = (store: RootState) => store.wellGuardian.selectedSection;
export const useSelectedSection = () => useSelector(getSelectedSection);

const getActiveWIRStep = (store: RootState) => store.wellGuardian.activeWIRStep;
export const useActiveWIRStep = () => useSelector(getActiveWIRStep);

const getActiveR2SLink = (store: RootState) => store.wellGuardian.r2SLink;
export const useActiveR2SLink = () => useSelector(getActiveR2SLink);

const getWIRUsers = (store: RootState) => store.wellGuardian.wirUsers;
export const useWIRUsers = () => useSelector(getWIRUsers);

const getWIRList = (store: RootState) => store.wellGuardian.wirList;
export const useWIRList = () => useSelector(getWIRList);

const getWIRCreateSelectedTab = (store: RootState) => store.wellGuardian.wirCreateSelectedTab;
export const useWIRCreateSelectedTab = () => useSelector(getWIRCreateSelectedTab);

const getInfoTab = (store: RootState) => store.wellGuardian.selectedInfo;
export const useInfoTab = () => useSelector(getInfoTab);

const getInfoTips = (store: RootState) => store.wellGuardian.infoTips;
export const useInfoTips = () => useSelector(getInfoTips);

const getUpdateDownload = (store: RootState) => store.wellGuardian.downloadPDF;
export const useDownloadData = () => useSelector(getUpdateDownload);

const getWIRDraftComment = (store: RootState) => store.wellGuardian.wirDraftComment;
export const useWIRDraftComment = () => useSelector(getWIRDraftComment);

const getSelectCommentWIR = (store: RootState) => store.wellGuardian.selectCommentWIR;
export const useSelectCommentWIR = () => useSelector(getSelectCommentWIR);

const getInterventionDraftComment = (store: RootState) =>
  store.wellGuardian.interventionDraftComment;
export const useInterventionDraftComment = () => useSelector(getInterventionDraftComment);

const getWIRInterventionSelectedTab = (store: RootState) =>
  store.wellGuardian.wirInterventionSelectedTab;
export const useWIRInterventionSelectedTab = () => useSelector(getWIRInterventionSelectedTab);

const getCountryData = (store: RootState) => store.wellGuardian.countryState;
export const useCountryState = () => useSelector(getCountryData);

const getMapCountry = (store: RootState) => store.wellGuardian.mapCountry;
export const useMapCountry = () => useSelector(getMapCountry);

const getReviewChecklist = (store: RootState) => store.wellGuardian.reviewChecklist;
export const useReviewChecklist = () => useSelector(getReviewChecklist);

const getSelectedWSActiveJob = (store: RootState) => store.wellGuardian.selectedWSActiveJob;
export const useSelectedWSActiveJob = () => useSelector(getSelectedWSActiveJob);

const getSelectedWSTask = (store: RootState) => store.wellGuardian.selectedWSTask;
export const useSelectedWSTask = () => useSelector(getSelectedWSTask);

const getDeadlineCheck = (store: RootState) => store.wellGuardian.deadlineCheck;
export const useDeadlineCheck = () => useSelector(getDeadlineCheck);

const getPrimaveraJobId = (store: RootState) => store.wellGuardian.primaveraJobId;
export const usePrimaveraJobId = () => useSelector(getPrimaveraJobId);

const getAllWirUsers = (store: RootState) => store.wellGuardian.allWirUsers;
export const useAllWirUsers = () => useSelector(getAllWirUsers);

const getCurrentTimezone = (store: RootState) => store.wellGuardian.currentTimezone;
export const useSelectCurrentTimezone = () => useSelector(getCurrentTimezone);

const getAllWellReviewsDownload = (store: RootState) => store.wellGuardian.allReviewsDownload;
export const useAllWellReviewsDownload = () => useSelector(getAllWellReviewsDownload);

const getToggleSwitch = (store: RootState) => store.wellGuardian.toggleSwitch;
export const useToggleSwitch = () => useSelector(getToggleSwitch);
